var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9545 4.61364H10.7727V0.363636H9.38636V4.61364H5.86364L2.90909 0.363636H1.54545V4.61364H0.363636V5.75H1.54545V7.06818H0.363636V8.20455H1.54545V12H2.95455V8.20455H6.77273L9.40909 12H10.7727V8.20455H11.9545V7.06818H10.7727V5.75H11.9545V4.61364ZM5.07386 5.75L5.98864 7.06818H2.95455V5.75H5.07386ZM9.38636 5.75V7.06818H7.56818L6.65341 5.75H9.38636ZM2.95455 4.61364V2.86364H3.06818L4.28409 4.61364H2.95455ZM8.35795 8.20455H9.38636V9.52273H9.27273L8.35795 8.20455Z",
    fill: "#81909D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.959c9214.svg";
export { ForwardRef as ReactComponent };